import { html, LitElement } from 'lit';

export default class HeaderWebComponent extends LitElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    data: { type: Object },
    basepath: { type: String },
    program_id: { type: String }
  };

  constructor() {
    super();
    this.data = {};
    this.basepath = '';
    this.program_id = '';
  }

  async connectedCallback() {
    super.connectedCallback();

    // console.log(this.data, 'BUENAS header ');
  }

  // updated(changedProperties) {
  //   if (changedProperties.has('data')) {
  //     console.log(`Data en el hijo cambió a: ${this.data}`);
  //   }
  // }

  render() {
    const { data, basepath, program_id } = this;

    const { logoheader } = data;

    const { url, alternativeText } = logoheader || '';

    const newUrl = String(url).replace('/uploads/', '') || '';

    return html`
      <section class="header-component">
        <img
          class="header-component-logo"
          src=${logoheader
    ? `${basepath}/dist/${program_id}/img/${newUrl}`
    : '/img/logo-default.jpg'}
          alt=${alternativeText || 'Logo'}
        />
      </section>
    `;
  }
}

customElements.define('header-webcomponent', HeaderWebComponent);
